var _g, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoho(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.00 0.00 48.00 48.00",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "butt"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#f29293",
    vectorEffect: "non-scaling-stroke",
    d: "   M 22.72 3.60   Q 19.65 4.02 16.22 4.53   Q 11.84 5.18 9.89 6.08   Q 3.79 8.90 2.53 16.25   Q 2.13 18.61 3.58 25.11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fcd98e",
    vectorEffect: "non-scaling-stroke",
    d: "   M 3.58 25.11   Q 3.99 28.48 4.57 32.23   Q 5.28 36.78 6.50 38.94   C 9.53 44.32 14.77 46.04 20.68 45.17   Q 23.09 44.82 25.53 44.39"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#91b6da",
    vectorEffect: "non-scaling-stroke",
    d: "   M 25.53 44.39   C 29.75 43.78 35.24 43.43 38.66 41.65   Q 44.52 38.58 45.48 31.26   Q 45.72 29.47 44.61 23.94"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#84cca4",
    vectorEffect: "non-scaling-stroke",
    d: "   M 44.61 23.94   Q 44.08 20.18 43.45 16.12   Q 42.64 10.96 41.23 8.62   Q 37.94 3.17 30.75 2.49   Q 29.00 2.32 22.72 3.60"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#15837f",
    vectorEffect: "non-scaling-stroke",
    d: "   M 44.61 23.94   Q 39.61 27.27 36.08 24.01"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#84cca4",
    vectorEffect: "non-scaling-stroke",
    d: "   M 36.08 24.01   L 34.51 14.35   A 4.02 4.01 -9.0 0 0 29.94 11.03   L 23.08 12.08"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#765f38",
    vectorEffect: "non-scaling-stroke",
    d: "   M 23.08 12.08   Q 28.56 8.10 22.72 3.60"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f29293",
    vectorEffect: "non-scaling-stroke",
    d: "   M 23.08 12.08   Q 19.11 12.69 15.21 13.35   C 9.32 14.34 11.17 19.35 11.82 23.49"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ef6c22",
    vectorEffect: "non-scaling-stroke",
    d: "   M 11.82 23.49   Q 6.56 20.66 3.58 25.11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#91b6da",
    vectorEffect: "non-scaling-stroke",
    d: "   M 36.08 24.01   L 36.97 30.06   A 3.91 3.90 -8.8 0 1 33.72 34.49   L 24.66 35.94"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fcd98e",
    vectorEffect: "non-scaling-stroke",
    d: "   M 24.66 35.94   L 18.02 36.95   A 3.97 3.96 -9.0 0 1 13.51 33.68   L 11.82 23.49"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8e9069",
    vectorEffect: "non-scaling-stroke",
    d: "   M 24.66 35.94   Q 19.39 40.68 25.53 44.39"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "   M 28.81 0.00   L 33.22 0.00   Q 43.71 2.51 45.34 12.75   Q 47.29 24.95 48.00 28.81   L 48.00 33.25   Q 46.40 39.97 41.39 43.09   Q 38.78 44.72 30.74 46.02   Q 24.97 46.95 19.20 48.00   L 14.76 48.00   Q 4.29 45.48 2.66 35.25   Q 0.71 23.01 0.00 19.14   L 0.00 14.74   Q 2.58 4.12 12.50 2.70   Q 20.66 1.52 28.81 0.00   Z   M 22.72 3.60   Q 19.65 4.02 16.22 4.53   Q 11.84 5.18 9.89 6.08   Q 3.79 8.90 2.53 16.25   Q 2.13 18.61 3.58 25.11   Q 3.99 28.48 4.57 32.23   Q 5.28 36.78 6.50 38.94   C 9.53 44.32 14.77 46.04 20.68 45.17   Q 23.09 44.82 25.53 44.39   C 29.75 43.78 35.24 43.43 38.66 41.65   Q 44.52 38.58 45.48 31.26   Q 45.72 29.47 44.61 23.94   Q 44.08 20.18 43.45 16.12   Q 42.64 10.96 41.23 8.62   Q 37.94 3.17 30.75 2.49   Q 29.00 2.32 22.72 3.60   Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#089949",
    d: "   M 44.61 23.94   Q 39.61 27.27 36.08 24.01   L 34.51 14.35   A 4.02 4.01 -9.0 0 0 29.94 11.03   L 23.08 12.08   Q 28.56 8.10 22.72 3.60   Q 29.00 2.32 30.75 2.49   Q 37.94 3.17 41.23 8.62   Q 42.64 10.96 43.45 16.12   Q 44.08 20.18 44.61 23.94   Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e42527",
    d: "   M 22.72 3.60   Q 28.56 8.10 23.08 12.08   Q 19.11 12.69 15.21 13.35   C 9.32 14.34 11.17 19.35 11.82 23.49   Q 6.56 20.66 3.58 25.11   Q 2.13 18.61 2.53 16.25   Q 3.79 8.90 9.89 6.08   Q 11.84 5.18 16.22 4.53   Q 19.65 4.02 22.72 3.60   Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "   M 36.08 24.01   L 36.97 30.06   A 3.91 3.90 -8.8 0 1 33.72 34.49   L 24.66 35.94   L 18.02 36.95   A 3.97 3.96 -9.0 0 1 13.51 33.68   L 11.82 23.49   C 11.17 19.35 9.32 14.34 15.21 13.35   Q 19.11 12.69 23.08 12.08   L 29.94 11.03   A 4.02 4.01 -9.0 0 1 34.51 14.35   L 36.08 24.01   Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9b21d",
    d: "   M 11.82 23.49   L 13.51 33.68   A 3.97 3.96 -9.0 0 0 18.02 36.95   L 24.66 35.94   Q 19.39 40.68 25.53 44.39   Q 23.09 44.82 20.68 45.17   C 14.77 46.04 9.53 44.32 6.50 38.94   Q 5.28 36.78 4.57 32.23   Q 3.99 28.48 3.58 25.11   Q 6.56 20.66 11.82 23.49   Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#226db4",
    d: "   M 36.08 24.01   Q 39.61 27.27 44.61 23.94   Q 45.72 29.47 45.48 31.26   Q 44.52 38.58 38.66 41.65   C 35.24 43.43 29.75 43.78 25.53 44.39   Q 19.39 40.68 24.66 35.94   L 33.72 34.49   A 3.91 3.90 -8.8 0 0 36.97 30.06   L 36.08 24.01   Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoho);
export default __webpack_public_path__ + "static/media/zoho.150c745986023ca574d12074118b2dec.svg";
export { ForwardRef as ReactComponent };